/**
 * Valores sugeridos para a configuração inicial em menos de 3 minutos (épico 1.2).
 * Preços de referência: seção 6.2 do plano (médias; a profissional ajusta).
 */
export interface SuggestedService {
  name: string;
  duration_min: number;
  price_cents: number;
  return_days: number | null;
  audience: 'nails' | 'aesthetics';
}

export const SUGGESTED_SERVICES: SuggestedService[] = [
  { name: 'Esmaltação', duration_min: 40, price_cents: 3500, return_days: 7, audience: 'nails' },
  { name: 'Pé e mão', duration_min: 90, price_cents: 5000, return_days: 14, audience: 'nails' },
  { name: 'Aplicação de gel', duration_min: 120, price_cents: 22000, return_days: 21, audience: 'nails' },
  { name: 'Manutenção de gel', duration_min: 90, price_cents: 12000, return_days: 21, audience: 'nails' },
  { name: 'Alongamento', duration_min: 150, price_cents: 20000, return_days: 21, audience: 'nails' },
  { name: 'Limpeza de pele', duration_min: 60, price_cents: 15000, return_days: 30, audience: 'aesthetics' },
  { name: 'Drenagem linfática', duration_min: 60, price_cents: 12000, return_days: 7, audience: 'aesthetics' },
  { name: 'Massagem', duration_min: 60, price_cents: 14000, return_days: 14, audience: 'aesthetics' },
  { name: 'Depilação', duration_min: 40, price_cents: 6000, return_days: 30, audience: 'aesthetics' },
];

/**
 * Cores dos serviços, na ordem de SUGGESTED_SERVICES (esmaltação, pé e mão, aplicação de gel, manutenção de
 * gel, alongamento, limpeza de pele, drenagem, massagem). Sem coral: o coral é a cor do "agora" (docs/design).
 */
export const SERVICE_COLORS = ['#C2185B', '#B7791F', '#5D6D7E', '#7A1F45', '#3D5A98', '#6E57A8', '#2E7D6B', '#9A4A1F'];

/** Cor de um serviço sugerido pelo nome; para os outros, a próxima da lista. */
export function serviceColorFor(name: string, index: number): string {
  const i = SUGGESTED_SERVICES.findIndex((s) => s.name === name);
  return SERVICE_COLORS[(i >= 0 ? i : index) % SERVICE_COLORS.length]!;
}

/** Fusos do Brasil com o nome da cidade de referência (seção 15.4). */
export const BRAZIL_TIMEZONES: Array<{ id: string; label: string }> = [
  { id: 'America/Sao_Paulo', label: 'Brasília / São Paulo' },
  { id: 'America/Manaus', label: 'Manaus' },
  { id: 'America/Cuiaba', label: 'Cuiabá' },
  { id: 'America/Campo_Grande', label: 'Campo Grande' },
  { id: 'America/Porto_Velho', label: 'Porto Velho' },
  { id: 'America/Boa_Vista', label: 'Boa Vista' },
  { id: 'America/Rio_Branco', label: 'Rio Branco' },
  { id: 'America/Belem', label: 'Belém' },
  { id: 'America/Fortaleza', label: 'Fortaleza' },
  { id: 'America/Recife', label: 'Recife' },
  { id: 'America/Bahia', label: 'Salvador' },
  { id: 'America/Maceio', label: 'Maceió' },
  { id: 'America/Araguaina', label: 'Palmas / Araguaína' },
  { id: 'America/Santarem', label: 'Santarém' },
  { id: 'America/Noronha', label: 'Fernando de Noronha' },
];

export function timezoneLabel(id: string): string {
  return BRAZIL_TIMEZONES.find((t) => t.id === id)?.label ?? id.split('/').pop()?.replace(/_/g, ' ') ?? id;
}

/** Horário de trabalho sugerido: terça a sábado, das 9h às 18h (seção 12.1). */
export const SUGGESTED_RULES: Array<{ weekday: number; start: string; end: string }> = [2, 3, 4, 5, 6].map((weekday) => ({
  weekday,
  start: '09:00',
  end: '18:00',
}));

export const WEEKDAY_NAMES = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
export const WEEKDAY_SHORT = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
export const MONTH_NAMES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];
